import React from 'react';
import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  configApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { claudeFlowApiRef, ClaudeFlowClient } from './api';

export const claudeFlowPlugin = createPlugin({
  id: 'claude-flow',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: claudeFlowApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new ClaudeFlowClient(discoveryApi, fetchApi),
    }),
  ],
});

// Export the routable extension for plugin installation
export const ClaudeFlowPageExtension = claudeFlowPlugin.provide(
  createRoutableExtension({
    name: 'ClaudeFlowPage',
    component: () =>
      import('./components/ClaudeFlowPage').then(m => m.ClaudeFlowPage),
    mountPoint: rootRouteRef,
  }),
);

// Export a simple component wrapper for direct use in routes
// This avoids the AppProvider context issue
export const ClaudeFlowPage = () => {
  const LazyComponent = React.lazy(() =>
    import('./components/ClaudeFlowPage').then(module => ({
      default: module.ClaudeFlowPage,
    }))
  );

  return React.createElement(
    React.Suspense,
    { fallback: React.createElement('div', {}, 'Loading Claude Flow...') },
    React.createElement(LazyComponent)
  );
};
